{
  "longPressMessage": "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
}
